export class TestSupport {
	public static readonly DISABLE_METADATA_CALLS_PROPERTY = '__awc_disable_metadata_calls__';
	public static readonly DISABLE_EVENT_CALLS_PROPERTY = '__awc_disable_event_calls__';
	public static readonly DISABLE_FETCH_CALLS_PROPERTY = '__awc_disable_fetch_calls__';
	public static readonly SYNTHETIC_FLAG_OVERRIDE_PROPERTY = '__awc_synthetic_flag_override__';

	public static isGeminiVREnvironment(): boolean {
		try {
			for (const k in global) {
				if (k.startsWith('__gemini_') && k.endsWith('__')) {
					return true;
				}
			}
		} catch (e) {
			// ignore
		}
		return false;
	}

	public static areMetadataCallsDisabled(): boolean {
		return (
			this.areFetchCallsDisabled() ||
			this.getGlobalBooleanProperty(TestSupport.DISABLE_METADATA_CALLS_PROPERTY)
		);
	}

	public static areEventCallsDisabled(): boolean {
		return (
			this.areFetchCallsDisabled() ||
			this.getGlobalBooleanProperty(TestSupport.DISABLE_EVENT_CALLS_PROPERTY)
		);
	}

	public static areFetchCallsDisabled(): boolean {
		return this.getGlobalBooleanProperty(TestSupport.DISABLE_FETCH_CALLS_PROPERTY);
	}

	public static getSyntheticFlagOverride(): boolean | undefined {
		return this.getGlobalTriStateProperty(TestSupport.SYNTHETIC_FLAG_OVERRIDE_PROPERTY);
	}

	private static getGlobalBooleanProperty(propertyName: string): boolean {
		if (global && global.hasOwnProperty(propertyName)) {
			return (global as any)[propertyName] === true;
		}
		return false;
	}

	private static getGlobalTriStateProperty(propertyName: string): boolean | undefined {
		if (global && global.hasOwnProperty(propertyName)) {
			const value = (global as any)[propertyName];
			if (typeof value === 'boolean') {
				return value;
			}
		}
		return undefined;
	}
}
